import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import PainLevel from './painLevel';
import ThankYouPopup from './ThankYouPopup';

export default class Service1333 extends Component {

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1333">
        <Switch>
          <Route path="/pain_monitoring/thankyou"
                 render={routeProps => (<ThankYouPopup {...routeProps} /> )}
          />
          <Route path="/pain_monitoring"
                 render={routeProps => ( <PainLevel {...routeProps} /> )}
          />
        </Switch>
      </div>
    );
  }
}